import React from "react";
import { MdDeleteOutline } from "react-icons/md";

const TableItemsNotificationsResponsive = ({ dataNotifications }) => {
  const notificationsArray = Array.isArray(dataNotifications) ? dataNotifications : [];

  return (
    <>
      {notificationsArray.map((item, index) => (
        <div
          key={item.id || index}
          className="bg-white dark:bg-gray-800 shadow rounded-lg p-4 text-sm space-y-2"
        >
          <p>
            <strong>Titulli:</strong> {item.title}
          </p>
          <p>
            <strong>Mesazhi:</strong> {item.message}
          </p>
          <div className="flex justify-end pt-2">
            <MdDeleteOutline className="w-6 h-6 cursor-pointer text-red-600" />
          </div>
        </div>
      ))}
    </>
  );
};

export default TableItemsNotificationsResponsive; 